(function () {
  const ANIMATION_MS = 450;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getPanelClip(item) {
    return item.querySelector('.biomarkers-health__panel-clip');
  }

  function nextFrame() {
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(resolve);
      });
    });
  }

  function waitForHeightTransition(clip) {
    return new Promise((resolve) => {
      if (!clip || prefersReducedMotion()) {
        resolve();
        return;
      }

      let settled = false;

      const finish = () => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeoutId);
        clip.removeEventListener('transitionend', onEnd);
        resolve();
      };

      const onEnd = (event) => {
        if (event.target !== clip) return;
        if (event.propertyName !== 'height') return;
        finish();
      };

      const timeoutId = window.setTimeout(finish, ANIMATION_MS + 100);
      clip.addEventListener('transitionend', onEnd);
    });
  }

  async function closeItem(item) {
    if (!item.open || item.classList.contains('is-animating')) return;

    const clip = getPanelClip(item);

    if (!clip || prefersReducedMotion()) {
      item.open = false;
      item.classList.remove('is-animating', 'is-closing');
      clip && (clip.style.height = '');
      return;
    }

    // Lock current pixel height while CSS still has height: auto,
    // otherwise adding is-animating snaps to height: 0 immediately.
    const startHeight = clip.scrollHeight;
    clip.style.height = `${startHeight}px`;
    item.classList.add('is-animating', 'is-closing');

    await nextFrame();
    clip.style.height = '0px';

    await waitForHeightTransition(clip);

    item.open = false;
    item.classList.remove('is-animating', 'is-closing');
    clip.style.height = '';
  }

  async function openItem(item) {
    if (item.open || item.classList.contains('is-animating')) return;

    const clip = getPanelClip(item);

    if (!clip || prefersReducedMotion()) {
      item.open = true;
      item.classList.remove('is-animating', 'is-closing');
      clip && (clip.style.height = '');
      return;
    }

    item.classList.add('is-animating');
    item.classList.remove('is-closing');
    item.open = true;
    clip.style.height = '0px';

    await nextFrame();
    clip.style.height = `${clip.scrollHeight}px`;

    await waitForHeightTransition(clip);

    item.classList.remove('is-animating');
    clip.style.height = '';
  }

  function initAccordion(root) {
    if (!root || root.dataset.biomarkersHealthInitialized === 'true') return;

    root.dataset.biomarkersHealthInitialized = 'true';

    const items = [...root.querySelectorAll('details.biomarkers-health__item')];

    for (const item of items) {
      const summary = item.querySelector('summary');
      if (!summary) continue;

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        if (item.classList.contains('is-animating')) return;
        if (items.some((other) => other !== item && other.classList.contains('is-animating'))) return;

        if (item.open) {
          closeItem(item);
          return;
        }

        const openItems = items.filter(
          (other) => other !== item && (other.open || other.classList.contains('is-animating'))
        );

        Promise.all(openItems.map((other) => closeItem(other))).then(() => {
          openItem(item);
        });
      });
    }
  }

  function initAll() {
    const sections = document.querySelectorAll('[data-biomarkers-health-impacts]');

    for (const section of sections) {
      const accordion = section.querySelector('[data-biomarkers-health-accordion]');
      initAccordion(accordion);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target?.querySelector?.('[data-biomarkers-health-impacts]') || event.target;
    if (!section?.matches?.('[data-biomarkers-health-impacts]')) return;

    const accordion = section.querySelector('[data-biomarkers-health-accordion]');
    if (accordion) {
      delete accordion.dataset.biomarkersHealthInitialized;
      initAccordion(accordion);
    }
  });
})();
